module.exports = __webpack_public_path__ + "img/contacto.a003a888.png";